import {Button} from 'primereact/button'
import AccessDeniedImg from '../../assets/images/AccessDenied.svg'
import DeactivatedAccountImg from '../../assets/images/DeactivatedAccount.svg'
import DischargedAccountImg from '../../assets/images/DischargedAccount.svg'
const GenericError = ({type = '', onClose = () => {}}) => {
    const genericList = {
        accessDenied: {
            img: AccessDeniedImg,
            label: 'ACCESS DENIED',
            description: (
                <div>
                    <h6 className="mb-0">
                        Your account seems like it doesn't exist or it's not
                        authorized to access
                    </h6>
                    <h6>
                        Please contact your administrator for further
                        authentication
                    </h6>
                </div>
            ),
        },
        discharged: {
            img: DischargedAccountImg,
            label: 'ACCOUNT DISCHARGED',
            description: (
                <div>
                    <h6 className="mb-0">
                        Your account has been discharged from the system
                    </h6>
                    <h6>
                        Please contact your administrator to re-gain your access
                    </h6>
                </div>
            ),
        },
        deactivated: {
            img: DeactivatedAccountImg,
            label: 'ACCOUNT DEACTIVATED',
            description: (
                <div>
                    <h6 className="mb-0">
                        Your account has been deactivated from the system
                    </h6>
                    <h6>
                        Please contact your administrator to re-activate your
                        account
                    </h6>
                </div>
            ),
        },
    }
    return (
        <div className="flex col-12 md:col-12  align-items-center justify-content-center overflow-hidden">
            <div
                className="flex flex-column align-items-center justify-content-center"
                style={{minHeight: '60vh'}}>
                <div
                    style={{
                        borderRadius: '56px',
                        padding: '0.3rem',
                        background:
                            'linear-gradient(180deg, rgba(20,184,166, 0.4) 15%, rgba(20,184,166, 0) 70%)',
                    }}>
                    <div
                        className="surface-card py-8 px-5 sm:px-8 flex flex-column justify-items-center"
                        style={{borderRadius: '53px'}}>
                        <h2 className=" text-primary text-5xl text-center mb-1 font-bold">
                            {type && genericList[type].label}
                        </h2>
                        <div className="text-color text-2xl text-center mb-5">
                            {type && genericList[type].description}
                        </div>
                        <img
                            src={type && genericList[type].img}
                            alt={genericList[type].label}
                            className="mt-4 mb-7"
                            height="160"
                        />

                        <Button
                            icon="pi pi-times"
                            label="CLOSE"
                            className="p-button-rounded"
                            onClick={() => onClose()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GenericError
